import { inject } from '@angular/core';
import { ConfigLoaderService } from './shared/services/api-services/configLoader.service';

export const appInitializer = () => {
  const configService = inject(ConfigLoaderService);
  return configService.loadConfig(); // directly return the Promise
};
